import {useFetchTableData} from './useFetchTableData';

export const useFetchCount = props => {
  const {data: {count} = {}} = useFetchTableData({...props, count: true});
  return count;
};
